// components
import GridPageAbstract from '../../GridPageAbstract';
import { UserOctagonBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class MerchantInvitesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'merchantInvites';
        this.Server = this.props.context.getState().server.merchantInvites;

        this.headerStartIcon = UserOctagonBulkIcon;

        this.hiddenColumns = config?.hiddenColumns?.merchantInvites || [];

        this.Head = [
            {
                id: 'merchantId',
                label: 'merchant',
                object: 'merchant',
                alignRight: false,
                cell: 'Select',
                from: 'merchants',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'merchants'
            },
            {
                id: 'coinId',
                sortField: 'coin.name',
                label: 'coin',
                object: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'coins',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'coins'
            },
            { id: 'secret', label: 'secret', alignRight: false, cell: 'Text' },
            {
                id: 'expirationDate',
                label: 'expirationDate',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date'
            },
            {
                id: 'activatedAt',
                label: 'activatedAt',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
